var map = {
	"./1.jpg": "2905",
	"./2.jpg": "9d38",
	"./3.jpg": "af7a",
	"./4.jpg": "6343",
	"./5.jpg": "c2da",
	"./6.jpg": "36a4",
	"./7.jpg": "b918"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d06d";